import * as React from 'react';
import { is, fromJS } from 'immutable';
import * as ReactDOM from 'react-dom';
import Confirm from './Confirm';
import './index.css';

let defaultState = {
    title: '提示',
    alertStatus: false,
    alertTip: "提示",
    className: '',
    closeDialog: function () { },
    childs: ''
}

class Dialog extends React.Component {

    state = {
        ...defaultState
    };
    // css动画组件设置为目标组件
    FirstChild = props => {
        const childrenArray = React.Children.toArray(props.children);
        return childrenArray[0] || null;
    }
    //打开弹窗
    open = (options) => {
        options = options || {
            title: '提示'
        };
        options.alertStatus = true;
        var props = options.props || {};
        var childs = this.renderChildren(props, options.childrens) || '';
        this.setState({
            ...defaultState,
            ...options,
            childs
        })
    }
    confirm = (options) => {
        options.alertStatus = true;
        var props = {
            title: options.title || '提示',
            content: options.content || '',
            okText: options.okText || '确定',
            showFooter: options.showFooter !== undefined ? options.showFooter : true,
            onOk: options.onOk || (() => {})
        };
        var childs = this.renderChildren(props, [Confirm]) || '';

        this.setState({
            ...defaultState,
            ...options,
            childs
        })
    }
    //关闭弹窗
    close() {
        const {destroy} = this.props;
        this.state.closeDialog();
        this.setState({
            ...defaultState
        });
        destroy && destroy();
    }
    renderChildren(props, childrens) {
        //遍历所有子组件
        var childs = [];
        childrens = childrens || [];
        var ps = {
            ...props,  //给子组件绑定props
            _close: this.close.bind(this)  //给子组件也绑定一个关闭弹窗的事件
        };
        childrens.forEach((currentItem, index) => {
            childs.push(React.createElement(
                currentItem,
                {
                    ...ps,
                    key: index
                }
            ));
        })
        return childs;
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !is(fromJS(this.props), fromJS(nextProps)) || !is(fromJS(this.state), fromJS(nextState))
    }

    render() {
        const { className = '' } = this.state;
        return (
            <div className={['w-modal-wrap w-modal-with-gift-wrap', className].join(' ')} style={this.state.alertStatus ? { display: 'block' } : { display: 'none' }}>
                <div className="w-modal-spacer"></div>
                <div className="w-modal">
                    <div className="w-modal-close" onClick={this.close.bind(this)}></div>
                    <div className="w-modal-body">
                        {this.state.childs}
                    </div>
                </div>
            </div>
        );
    }
}

function createDialog() {
    let div = document.createElement('div');

    document.body.appendChild(div);

    let Box = ReactDOM.render(React.createElement(
        Dialog,
        {
            destroy() {
                ReactDOM.unmountComponentAtNode(div);
                document.body.removeChild(div);
            }
        }
    ), div);
    return Box;
}

const getDialog = () => {
    return createDialog();
}

export default {
    open(options) {
        getDialog().open(options);
    },
    confirm(options) {
        getDialog().confirm(options);
    }
};